import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: {
      main: '#00B9F2',
      contrastText: '#fff',

    },
    secondary: {
      main: '#ff0000',
      contrastText: '#fff',
    },

  },
});
